
import countriesJson from "./Countries.json";

export const COUNTRIES_CODES = countriesJson.map((country)=>{
    return {
        value:country.code,
        label:country.name,
    }
});

export const COUNTRIES_NUMBERCODES = countriesJson.map((country)=>{
    return {
        value:country.dial_code,
        label:`${country.dial_code} (${country.code})`,
    }
})

export const NATIONALITIES = countriesJson
    .filter((country): country is typeof country & { nationality: string } => Boolean(country.nationality))
    .map((country) => {
        return {
            value: country.code,
            label: country.nationality,
        }
    });